// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grey-0": "#000",
	"grey-50": "#000",
	"grey-100": "#000",
	"grey-200": "#000",
	"grey-300": "#000",
	"grey-400": "#000",
	"grey-500": "#000",
	"grey-600": "#fff",
	"grey-700": "#fff",
	"grey-800": "#fff",
	"grey-900": "#fff",
	"pink-50": "#000",
	"pink-100": "#000",
	"pink-200": "#000",
	"pink-300": "#000",
	"pink-400": "#000",
	"pink-500": "#fff",
	"pink-600": "#fff",
	"pink-700": "#fff",
	"pink-800": "#fff",
	"pink-900": "#fff",
	"red-50": "#000",
	"red-100": "#000",
	"red-200": "#000",
	"red-300": "#000",
	"red-400": "#fff",
	"red-500": "#fff",
	"red-600": "#fff",
	"red-700": "#fff",
	"red-800": "#fff",
	"red-900": "#fff",
	"orange-50": "#000",
	"orange-100": "#000",
	"orange-200": "#000",
	"orange-300": "#fff",
	"orange-400": "#fff",
	"orange-500": "#fff",
	"orange-600": "#fff",
	"orange-700": "#fff",
	"orange-800": "#fff",
	"orange-900": "#fff",
	"yellow-50": "#000",
	"yellow-100": "#000",
	"yellow-200": "#000",
	"yellow-300": "#000",
	"yellow-400": "#000",
	"yellow-500": "#000",
	"yellow-600": "#000",
	"yellow-700": "#fff",
	"yellow-800": "#fff",
	"yellow-900": "#fff",
	"citron-50": "#000",
	"citron-100": "#000",
	"citron-200": "#000",
	"citron-300": "#000",
	"citron-400": "#000",
	"citron-500": "#000",
	"citron-600": "#fff",
	"citron-700": "#fff",
	"citron-800": "#fff",
	"citron-900": "#fff",
	"green-50": "#000",
	"green-100": "#000",
	"green-200": "#000",
	"green-300": "#000",
	"green-400": "#000",
	"green-500": "#000",
	"green-600": "#fff",
	"green-700": "#fff",
	"green-800": "#fff",
	"green-900": "#fff",
	"teal-50": "#000",
	"teal-100": "#000",
	"teal-200": "#000",
	"teal-300": "#000",
	"teal-400": "#000",
	"teal-500": "#000",
	"teal-600": "#fff",
	"teal-700": "#fff",
	"teal-800": "#fff",
	"teal-900": "#fff",
	"cyan-50": "#000",
	"cyan-100": "#000",
	"cyan-200": "#000",
	"cyan-300": "#000",
	"cyan-400": "#000",
	"cyan-500": "#000",
	"cyan-600": "#fff",
	"cyan-700": "#fff",
	"cyan-800": "#fff",
	"cyan-900": "#fff",
	"cyan-gradient-50": "#000",
	"cyan-gradient-100": "#000",
	"cyan-gradient-200": "#000",
	"cyan-gradient-300": "#000",
	"cyan-gradient-400": "#000",
	"cyan-gradient-500": "#fff",
	"cyan-gradient-600": "#fff",
	"cyan-gradient-700": "#fff",
	"cyan-gradient-800": "#fff",
	"cyan-gradient-900": "#fff",
	"blue-50": "#000",
	"blue-100": "#000",
	"blue-200": "#000",
	"blue-300": "#000",
	"blue-400": "#fff",
	"blue-500": "#fff",
	"blue-600": "#fff",
	"blue-700": "#fff",
	"blue-800": "#fff",
	"blue-900": "#fff",
	"indigo-50": "#000",
	"indigo-100": "#000",
	"indigo-200": "#000",
	"indigo-300": "#000",
	"indigo-400": "#fff",
	"indigo-500": "#fff",
	"indigo-600": "#fff",
	"indigo-700": "#fff",
	"indigo-800": "#fff",
	"indigo-900": "#fff",
	"purple-50": "#000",
	"purple-100": "#000",
	"purple-200": "#000",
	"purple-300": "#000",
	"purple-400": "#000",
	"purple-500": "#fff",
	"purple-600": "#fff",
	"purple-700": "#fff",
	"purple-800": "#fff",
	"purple-900": "#fff",
	"opaque-50": "#000",
	"opaque-100": "#000",
	"opaque-200": "#000",
	"opaque-300": "#000",
	"opaque-400": "#000",
	"opaque-500": "#000",
	"opaque-600": "#000",
	"opaque-700": "#000",
	"opaque-800": "#000",
	"opaque-900": "#000",
	"npo-brand-50": "#000",
	"npo-brand-100": "#000",
	"npo-brand-200": "#000",
	"npo-brand-300": "#000",
	"npo-brand-400": "#000",
	"npo-brand-500": "#fff",
	"npo-brand-600": "#fff",
	"npo-brand-700": "#fff",
	"npo-brand-800": "#fff",
	"npo-brand-900": "#fff",
	"eerst-dit-brand-50": "#000",
	"eerst-dit-brand-100": "#000",
	"eerst-dit-brand-200": "#000",
	"eerst-dit-brand-300": "#000",
	"eerst-dit-brand-400": "#fff",
	"eerst-dit-brand-500": "#fff",
	"eerst-dit-brand-600": "#fff",
	"eerst-dit-brand-700": "#fff",
	"eerst-dit-brand-800": "#fff",
	"eerst-dit-brand-900": "#fff",
	"whatsapp-brand-50": "#000",
	"whatsapp-brand-100": "#000",
	"whatsapp-brand-200": "#000",
	"whatsapp-brand-300": "#000",
	"whatsapp-brand-400": "#000",
	"whatsapp-brand-500": "#fff",
	"whatsapp-brand-600": "#fff",
	"whatsapp-brand-700": "#fff",
	"whatsapp-brand-800": "#fff",
	"whatsapp-brand-900": "#fff",
	"clubhouse-brand-50": "#000",
	"clubhouse-brand-100": "#000",
	"clubhouse-brand-200": "#000",
	"clubhouse-brand-300": "#000",
	"clubhouse-brand-400": "#fff",
	"clubhouse-brand-500": "#fff",
	"clubhouse-brand-600": "#fff",
	"clubhouse-brand-700": "#fff",
	"clubhouse-brand-800": "#fff",
	"clubhouse-brand-900": "#fff",
	"facebook": "#fff",
	"twitter": "#fff",
	"tiktok": "#fff",
	"spotify": "#000",
	"soundcloud": "#fff",
	"snapchat": "#000",
	"youtube": "#fff",
	"vimeo": "#fff",
	"instagram": "#fff"
};
module.exports = ___CSS_LOADER_EXPORT___;
